import PaginatedList, { type PaginatedListProps } from './PaginatedList';

export type { PaginatedListProps };
export default PaginatedList;
